import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from "highcharts/highcharts-more";
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-distribution',
  templateUrl: './distribution.component.html',
  styleUrls: ['./distribution.component.scss']
})
export class DistributionComponent implements OnInit {

  constructor(public globalService:GlobalService) { }
  @Input() guageValue: Array<any> = [];
  @Input() pageTab: any;
  @Input() index: any;
  @Input() kpiScore:any;
  @Input() GraphTytle:any;
  @Input() legend:any;
  @Input() checkgraph:string;
 @Input() xValue:any;
  ngOnInit() {

  }
  ngAfterViewInit() {
    setTimeout(()=>{
      let obj = {
        pagetab: this.pageTab,
        index: this.index
      };
      this.assignToGraph(obj);
    },0);
  }
  assignToGraph({ pagetab, index }) {
    let name = "data1";
    
    if(this.guageValue){
  // if(this.checkgraph == 'benchmarkings'){
   var hjson = this.guageValue;

   colorGraph = true;             
  
   var colorGraph=false;
  
  var objnameArr = [];//get date
  var finalArray = [];
  var color = ['#044BEC','#24CCB8','#FFC400','#f8e7a8','#F08080','#c9ede7','#FFE4B5','#FFE4E1'];
        //getDates
for(let i=0;i<hjson.length;i++){
    let obj = hjson[i];
    for(let j=0;j<obj.length;j++){
    let secObj = obj[j];
    if(this.xValue==='networktag'){
      secObj['name'] =  secObj['name'].substring(0,secObj['name'].lastIndexOf(" ") + 1);
    if(objnameArr.indexOf(secObj['name']) === -1){
    objnameArr.push(secObj['name']);
    }     
  }else{
    if(objnameArr.indexOf(secObj.name) === -1){
      objnameArr.push(secObj['name']);
      }  
  }
}
}
let static_legends = ['Poor (score: 1 to 2)','Average (score: 2 to 3)','Good (score: 3 to 4)'];
if(hjson && hjson.length>0){
for(let i=0;i<hjson[0].length;i++){
      finalArray.push({data:[],color:color[i],name:static_legends[i]});   
}
for(var i=0;i<hjson.length;i++){
  let obj = hjson[i];
    for(let j=0;j<obj.length;j++){
    let secObj = obj[j]; 
      finalArray[j]['data'].push({y:+(secObj['percentage'].toPrecision(4)),per:secObj['count']});
   }  
}
}

  }
       let a: any = document.getElementById('histogram'+this.pageTab+this.index);
     if(a){
      let _this = this;
        Highcharts.chart(a, {
        chart: {
          type: 'column'
        },
        title: {
            text: this.GraphTytle
          },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: objnameArr,
          crosshair: true,
          labels: {
            enabled: true,
            rotation: 0,
            formatter: function ():any {
                let str:any= this.value.toString();
                if(_this.xValue=='networktag'){
                  return '<span style="color:#666666;" title="' + this.value + '">' + str+ '</span>';
                }else{
                if(objnameArr.length>3){
                return '<span style="color:#666666;" title="' + this.value + '">' + str.substr(0,8)+(str.length>8?'..':'')+ '</span>';
                          }else{
                return '<span style="color:#666666;" title="' + this.value + '">' + str+ '</span>';
              }
                                      } },
              useHTML: true,
},
          min: 0,
          title: {
            text:this.xValue==undefined?this.globalService.orderType
            :((this.xValue && this.xValue.toLowerCase())==='networktag')?this.xValue+' '+'(Mbps)':this.xValue,
          },

        },
        yAxis: {
          allowDecimals: false,
          min: 0,
          labels: {
            enabled: true,
            rotation: 0,
            formatter: function ():any {
                return  this.value+'%';
},
},
          title: {
            text: this.kpiScore+'(Percentage)',
          },
        },
      tooltip: {
                pointFormat: 'Count: <b>{point.per}</b><br/><span class="graphtip">Percentage: <b>{point.y}</b></span>',
            },
        plotOptions: {
          column: {
            pointPadding: 0,
            borderRadius: 5,
            borderWidth: 2,
            groupPadding:0.05,
            stacking: 'percent',
            showInLegend:true,
            shadow: false,
            colorByPoint:colorGraph,
          }
        },
        series: finalArray
      });
    }
  }
  }
